import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { apiCallingPost } from '../api/services';
import { ToastContainer, toast } from "react-toastify";
import Pagination from "react-js-pagination";
import ListReject from '../pages/home/list-reject';
import noData from "../assets/images/no-data.png"
import moment from 'moment';
import ImagePopups from './image-popup';
import { FaImage } from "react-icons/fa";
import { FaVideo } from "react-icons/fa";
function VideoUploadRequest() {
  const { userData } = useSelector((state) => state.masterData);
  const [destinationList, setDestinationList] = useState([]);
  const [destListTCount, setDestListTCount] = useState("");
  const [selectedVideos, setSelectedVideos] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [offset, setOffset] = useState(0);
  const [itemsCountPerPage, setItemsCountPerPage] = useState(10);
  const [popupReject, SetPopupReject] = useState(false)
  const [rejectData, setRejectData] = useState([])
  const [ImagePopup, setImagePopupFlag] = useState(false);
  const [popupSelectData, setPopupSelectData] = useState([]);

  useEffect(() => {
    getData(offset);

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        cancelPopup();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  const rejectPopup = (data) => {
    setRejectData(data)
    SetPopupReject(true)
    document.body.style.overflow = 'hidden';
  }
  const popupTagShow = (data) => {
    setImagePopupFlag(true)
    setPopupSelectData(data)
    document.body.style.overflow = 'hidden';
  }
  const cancelPopup = () => {
    SetPopupReject(false)
    setImagePopupFlag(false)
    document.body.style.overflow = 'auto';
  }
  const sendMail = async (mailData) => {
    let postData = {
      functionName: "sendMailToUsers",
      jsonMailOptions: mailData
    }
    try {
      const response = await apiCallingPost(postData);
      const { data } = response;
      if (data.success === "1") {

      }
    } catch (error) { }
  }
  const getData = async (offsetNo) => {
    let postData = {
      userId: ["Super_admin", "APPROVER"].includes(userData?.roleDisplayName) ? "" : userData?.userId || "",
      offset: offsetNo,
      max: itemsCountPerPage,
      videoName: "",
      fromDate: "",
      toDate: "",
      videoApprovedStatus: "Open",
    };
    try {
      const response = await apiCallingPost("api/video/videoList", postData);
      const { data } = response;
      if (data.success === "1") {
        setDestinationList(data.dataArray);
        setDestListTCount(data.totalCount);
      } else {
        setDestinationList([]);
        setDestListTCount("");
      }
    } catch (error) {
      console.error("Error fetching destination data:", error);
      setDestinationList([]);
      setDestListTCount("");
    }
  };

  const approveList = async (videoIds) => {
    const postData = {
      videoId: videoIds,
      userId: userData?.userId,
    };
    try {
      const response = await apiCallingPost("api/video/approveVideo", postData); // Adjusted endpoint
      const { data } = response;
      if (data.success === "1") {
        toast.success(`Media Approved successfully.`);
        setSelectedVideos([])
        setTimeout(() => {
          getData(0); // Refresh data after approval
        }, 1000);
      } else {
        toast.error(`Something went wrong.`);
      }
    } catch (error) {
      console.error("Error approving videos:", error);
    }
  };

  const handlePageChange = (pageNumber) => {
    let offsetNo = (pageNumber - 1) * itemsCountPerPage;
    setOffset(offsetNo);
    setActivePage(pageNumber);
    getData(offsetNo);
  };

  const handleCheckboxChange = (e, video_id) => {
    if (e.target.checked) {
      setSelectedVideos((prevList) => [...prevList, video_id]);
    } else {
      setSelectedVideos((prevList) => prevList.filter((id) => id !== video_id));
    }
  };

  const handleSelectAllChange = (e) => {
    const allCurrentPageIds = destinationList.map((item) => item.video_id);
    if (e.target.checked) {
      setSelectedVideos((prevList) => Array.from(new Set([...prevList, ...allCurrentPageIds])));
    } else {
      setSelectedVideos((prevList) => prevList.filter((id) => !allCurrentPageIds.includes(id)));
    }
  };

  const isAllChecked = () => {
    const allCurrentPageIds = destinationList.map((item) => item.video_id);
    return allCurrentPageIds.every((id) => selectedVideos.includes(id));
  };
  const handleAcceptAll = () => {
    if (selectedVideos.length < 1) {
      toast.error("Please select at least one video / image to approve.");
      return;
    }
    approveList(selectedVideos, "APPROVED");
  };

  return (
    <div className='table-responsive'>
      <ToastContainer />
      {destListTCount > 0 ?
        <>
          <div className='text-end'>
            <button className='accept-all-btn' onClick={handleAcceptAll}>Accept All</button>
          </div>
          <table className="table table-bordered admin-list-table video-request-table">
            <thead>
              <tr>
                <th className='text-center position-relative'>
                  {/* {!destinationList.every((item) => (item.approveStatus === "Open") && (item.isApproved === 0)) && ( */}
                  <div className='checkbox-mark'>
                    <div className="checkbox-wrapper-1">
                      <input
                        id="select-all-checkbox"
                        className="substituted"
                        type="checkbox"
                        checked={isAllChecked()}
                        onChange={handleSelectAllChange}
                      />
                      <label htmlFor="select-all-checkbox"></label>
                    </div>
                  </div>
                  {/* )} */}
                  #
                </th>
                <th>Video / Image Title</th>
                <th>Admin Details</th>
                <th>Date</th>
                <th className='text-center'>Status</th>
              </tr>
            </thead>
            <tbody>
              {destinationList.map((data, i) => (
                <tr key={data.video_id} className='position-relative'>
                  <td className='text-center'>
                    {/* {((data.approveStatus === "Open") && (data.isApproved === 0)) && */}
                    <div className='checkbox-mark'>
                      <div className="checkbox-wrapper-1">
                        <input
                          type="checkbox"
                          id={`checkbox-${data.video_id}`}
                          className="substituted"
                          checked={selectedVideos.includes(data.video_id)}
                          onChange={(e) => handleCheckboxChange(e, data.video_id)}
                        />
                        <label htmlFor={`checkbox-${data.video_id}`}></label>
                      </div>
                    </div>
                    {/* } */}
                    {i + 1}
                  </td>
                  <td>
                    <p>{data.video_heading}</p>
                    {data.url && (
                      <div className='ms-1'>
                        <span className='play-btn' onClick={() => {
                          popupTagShow(data)
                        }}>
                          {data.fileTypeId == "1" ?
                            <FaImage className='cursor-pointer' size={13} />
                            :
                            <FaVideo className='cursor-pointer' size={13} />
                          }
                        </span>
                      </div>
                    )}
                  </td>
                  <td>
                    <div>{data.userDisplayName}</div>
                    <div className='sub-text'>{data.userEmailId}</div>
                  </td>
                  <td style={{whiteSpace:'nowrap'}}>{moment(data.videoCreatedOn).format('DD-MM-YYYY')}</td>
                  <td className='text-center'>
                    <button className='Modified w-75 mb-2' onClick={() => approveList([data.video_id])}>Accept</button>
                    <button className='rejected w-75' onClick={() => rejectPopup(data, i, `rejectBtn` + i, `reject-destination` + i)}
                    >Reject</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
        :
        <div className="noData d-flex flex-column">
          <div>
            <img src={noData} alt="noData" className="img-fluid" width="150" height="150" />
          </div>
          <div>No Data Available</div>
        </div>
      }
      {destListTCount > itemsCountPerPage &&
        <div className='pagination-wrapper mt-4'>
          <Pagination
            activePage={activePage}
            itemsCountPerPage={itemsCountPerPage}
            totalItemsCount={destListTCount}
            pageRangeDisplayed={5}
            onChange={(e) => handlePageChange(e)}
          />
        </div>
      }
      {ImagePopup
        &&
        <ImagePopups cancelPopup={cancelPopup} selectData={popupSelectData} />
      }
      {popupReject &&

        <ListReject rejectData={rejectData} userData={userData}
          cancelPopup={cancelPopup} getData={() => getData(0)}
          sendMail={sendMail}
        />

      }
    </div>
  );
}

export default VideoUploadRequest;
